import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';

type ContactLinkProps = {
  href: string;
  label: string;
  ariaLabel: string;
  iconSrc: string;
};

function ContactLink({ href, label, ariaLabel, iconSrc }: ContactLinkProps) {
  return (
    <Link
      href={href}
      aria-label={ariaLabel}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: pxToRem(10),
        paddingBlock: { mobile: 0, laptop: pxToRem(10) },
        paddingInline: { mobile: pxToRem(8), laptop: pxToRem(10) },
        color: 'common.white',
        fontFamily: '"Inter", sans-serif',
        fontWeight: 400,
        fontSize: pxToRem(12),
        lineHeight: 'normal',
        whiteSpace: 'nowrap',
        textDecorationColor: 'currentColor',
      }}
    >
      <Box
        component="img"
        src={iconSrc}
        alt=""
        aria-hidden="true"
        sx={{ width: pxToRem(24), height: pxToRem(24), display: 'block', flexShrink: 0 }}
      />
      {label}
    </Link>
  );
}

export function Footer() {
  const { footer } = conventionContent;
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        paddingBlock: pxToRem(24),
        paddingInline: { mobile: pxToRem(16), laptop: pxToRem(150) },
        width: '100%',
      }}
    >
      <Stack
        direction={{ mobile: 'column-reverse', laptop: 'row' }}
        sx={{
          alignItems: { mobile: 'center', laptop: 'flex-start' },
          justifyContent: 'space-between',
          gap: { mobile: pxToRem(8), laptop: 0 },
        }}
      >
        <Box
          component="img"
          src={footer.logoSrc}
          alt={footer.logoAlt}
          sx={{
            width: pxToRem(318),
            maxWidth: '100%',
            height: pxToRem(44),
            objectFit: 'contain',
            display: 'block',
          }}
        />
        <Stack
          component="address"
          direction={{ mobile: 'column', laptop: 'row' }}
          sx={{
            alignItems: 'center',
            gap: { mobile: pxToRem(12), laptop: 0 },
            fontStyle: 'normal',
          }}
        >
          <ContactLink {...footer.phone} />
          <ContactLink {...footer.email} />
        </Stack>
      </Stack>
    </Box>
  );
}
